export default __webpack_public_path__ + "static/media/rank_2.3e75722a.svg";